<template>
  <div id="app">
    <cmpPageTopbar v-if="!$route.meta.hideTopbar"></cmpPageTopbar>
    <cmpDialogLogin></cmpDialogLogin>
    <cmpDialogChangePwd></cmpDialogChangePwd>
    <cmpDialogRegist></cmpDialogRegist>
    <router-view/>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import cmpPageTopbar from '@/components/cmp-page-topbar';
import cmpDialogLogin from '@/components/cmp-dialog-login';
import cmpDialogChangePwd from '@/components/cmp-dialog-changePwd';
import cmpDialogRegist from '@/components/cmp-dialog-regist';
export default {
  name: 'App',
  components: {
    cmpPageTopbar,
    cmpDialogLogin,
    cmpDialogChangePwd,
    cmpDialogRegist,
  },
  computed: {
    ...mapGetters(['isLogined'])
  },
  mounted() {
    this.getCurrentUser().then(() => {
      if (!this.isLogined && this.$route.meta.islogin) {
        this.$router.push({name: 'home'})
      }
    })
  },
  methods: {
    ...mapActions(['getCurrentUser'])
  }
}
</script>

<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>
